__turbopack_context__.v({
  "logoLink": "LogoLink-module-scss-module__4dLjsa__logoLink",
});
